module.exports = __webpack_public_path__ + "static/media/Services-05.6677c306.jpg";